const en = {
  nav: {
    identita: 'Identity',
    prodotti: 'Products',
    attivita: 'Activity',
    servizi: 'Services',
    contatti: 'Contact',
    openMenu: 'Open menu',
    closeMenu: 'Close menu',
  },
  hero: {
    title1: 'BORN FROM NATURE',
    title2: 'TO BUILD A SUSTAINABLE',
    title3: 'WORLD',
    cta: 'Discover more',
    scroll: 'Scroll',
  },
  intro: {
    eyebrow: 'Identity',
    title: 'WE ARE MATTER, LAND, GROWTH AND HISTORY',
    body:
      "FIBER PLAST specializes in manufacturing pipes and tanks in fiberglass and reinforced thermoplastic materials, thanks to state-of-the-art production processes recognized worldwide. Using our proprietary Filament Winding technology, FIBER PLAST designs, manufactures and distributes tailor-made products in more than 30 countries — serving power plants, chemical, petrochemical, power, aerospace and marine industries.",
  },
  products: {
    eyebrow: 'Products',
    title: 'THE POWER OF FIBERGLASS',
    subtitle: 'Tailor-made solutions in fiberglass and reinforced thermoplastics, produced with our proprietary Filament Winding technology.',
    all: 'All products',
    discover: 'Discover more',
    back: 'All products',
    others: 'OTHER PRODUCTS',
    request: 'Request information',
    features: [
      'Proprietary Filament Winding technology',
      'Fiberglass (GRP) and reinforced thermoplastic materials',
      'Certified chemical and mechanical resistance',
      'Tailor-made production based on customer drawings',
      'Distribution in more than 30 countries worldwide',
    ],
  },
  activity: {
    eyebrow: 'Activity',
    title: 'PROJECTS FOR THE FUTURE',
    body: 'FIBER PLAST designs and manufactures pipes, tanks and various components (such as channels, cooling towers, electrolytic cells) for civil and industrial uses. We distribute tailor-made products, engineered around the customer’s needs, in more than 30 countries.',
    sinceLabel: 'Since 1978',
    sinceText: 'More than 45 years of experience in composite materials, from the heart of Sardinia to the world.',
    cta: 'Discover more',
    approachTitle: 'OUR APPROACH',
    sectorsTitle: 'APPLICATION SECTORS',
    intro: 'FIBER PLAST designs and manufactures pipes, tanks and various components — including channels, cooling towers and electrolytic cells — for civil and industrial uses. We work side by side with our customers from the design phase to on-site commissioning, ensuring quality, sustainability and cost optimization at every step.',
    steps: [
      { t: 'Needs analysis', d: 'Detailed study of technical and process requirements.' },
      { t: 'Engineering design', d: 'Custom solutions in fiberglass and reinforced thermoplastics.' },
      { t: 'Filament Winding production', d: 'Manufacturing using our proprietary, state-of-the-art technology.' },
      { t: 'Testing & inspection', d: 'Quality controls following the highest industry standards.' },
      { t: 'Delivery & installation', d: 'Logistics, on-site assistance and after-sales support.' },
    ],
  },
  services: {
    eyebrow: 'Services',
    title: 'GREEN ENGINEERING',
    body: 'FIBER PLAST provides on-site assistance and assembly for the materials supplied. We design our own products and take care of packaging and shipping in line with each customer’s requirements, ensuring continuity and quality at every project stage.',
  },
  identita: {
    eyebrow: 'Identity',
    title: 'BORN FROM NATURE TO BUILD A SUSTAINABLE WORLD',
    blocks: [
      {
        title: 'We are matter',
        body:
          "The material driver behind FIBER PLAST production is fiberglass, born from the alliance of two elements found in nature: fibers on one side and resin on the other. A durable coexistence that inspires the creation of works and infrastructures that surround everyday life: pipes, tanks, scrubber towers, GRP filters and reinforced thermoplastic components, as well as special items such as channels, cooling towers and electrolytic cells.",
      },
      {
        title: 'We are land',
        body:
          "The strength of our company history is rooted in the land where we were born. A distinctive value that expresses our identity and expertise. FIBER PLAST was founded in the heart of the Mediterranean Sea, on an island — Sardinia — where nature and environment coexist harmoniously with business growth and development.",
      },
      {
        title: 'We are growth',
        body:
          "The company has been operating since 1978, first in the local market and then expanding beyond borders. Today FIBER PLAST aims to further extend its general contractor network in the countries where it operates, through high-level know-how and premium raw materials that characterize every project. A distinctive trait capable of expanding the FIBER PLAST brand worldwide.",
        quote:
          "We were born in the heart of the Mediterranean Sea, on an island — Sardinia — where nature and environment coexist harmoniously, fostering the growth and development of enterprises.",
      },
      {
        title: 'We are history',
        body:
          "Composite materials are made from the combination of two or more elements (matrix, fibers, additives). From their combination comes a lightweight, resistant and durable product, with applications in aerospace, automotive, sports, electrotechnical and construction sectors.",
      },
    ],
  },
  contact: {
    eyebrow: 'Contact',
    title: "LET'S TALK ABOUT YOUR PROJECT",
    body: 'Would you like more information about our services or products? Do you have specific feedback or a special request? Fill in the form and we will get back to you as soon as possible.',
    fields: { name: 'First name', surname: 'Last name', email: 'Email', message: 'Message' },
    privacy: 'I have read and accept the',
    privacyLink: 'Privacy Policy',
    submit: 'Send',
    submitting: 'Sending…',
    okTitle: 'Message sent',
    okBody: 'We will get back to you as soon as possible.',
    errMissing: 'Please fill in name, email and message.',
    errMissingTitle: 'Missing fields',
    errPrivacyTitle: 'Privacy Policy',
    errPrivacy: 'You must accept the Privacy Policy to send the message.',
  },
  contatti: {
    legalOffice: 'Registered Office',
    opOffice: 'Operating Office',
    phone: 'Phone',
    fax: 'Fax',
  },
  footer: {
    opOffice: 'Operating Office',
    nav: 'Navigate',
    tagline: 'Made in Sardinia · Distributed in over 30 countries',
    rights: 'All rights reserved.',
    privacy: 'Privacy & Cookie Policy',
  },
  cta: {
    title: "FROM NATURE, FOR TOMORROW'S INDUSTRY",
    body: 'Lightweight, resistant and durable composite materials for power, chemical, marine and aerospace plants in over 30 countries.',
    button: 'Contact us',
  },
  video: {
    eyebrow: 'Video',
    title: 'FIBER PLAST IN ACTION',
    body: 'Discover our proprietary Filament Winding technology and the production processes that make FIBER PLAST components unique — from design to delivery.',
    stat1: 'Years',
    stat2: 'Countries',
    stat3: 'mm max',
  },
  stats: [
    { value: '45+', label: 'Years of experience' },
    { value: '30+', label: 'Countries served' },
    { value: '5000', label: 'mm max diameter' },
    { value: '1978', label: 'Founding year' },
  ],
  sectors: ['Power plants', 'Chemical industry', 'Petrochemical', 'Power', 'Aerospace', 'Marine'],
};

export default en;
